import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as actaType from 'constants/pdfTypes';
import { Document, Page, pdfjs } from 'react-pdf';
import { Modal, Row, Col, Button } from 'antd';
import './ModalPdf.scss';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const selectedActaType = (valueType) => {
  switch (valueType) {
    case actaType.PDF_ACTA_INICIO:
      return 'Acta de inicio';
    case actaType.PDF_ACTA_HALLAZGO:
      return 'Hallazgos Espectaculares';
    case actaType.PDF_ACTA_CIERRE:
      return 'Acta de cierre';
    case actaType.PDF_MEDIOS_IMPRESOS:
      return 'Medios impresos';
    case actaType.PDF_INTERNET:
      return 'Internet';
    case actaType.PDF_EVENTOS:
      return 'Visita a eventos de precampaña o campaña';
    case actaType.PDF_CASAS:
      return 'Visita a casas de precampaña o campaña';
    default:
      return 'Visor de PDF';
  }
};

const createNamePdf = (param1, param2, param3) => {
  const firstPartName = selectedActaType(param1).toLowerCase().replace(/\s+/g, '_');
  let secondPartName = '';
  if (param2 !== undefined || param2 !== null) {
    secondPartName = Number.isNaN(param2) ? '' : param2;
  }
  let thirdPartName = '';
  if (param3) {
    thirdPartName = Number.isNaN(param3) ? '' : param3;
  }
  return `${firstPartName}_${secondPartName}_${thirdPartName}.pdf`;
};

const ModalPdf = ({
  open,
  tipoActa,
  callback,
  pdfActa,
  ultimaActualizacion,
  usuario,
  titulo,
  idMonitoreo,
  idActa
}) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);

  // Callback para manejar la carga del documento
  // eslint-disable-next-line no-shadow
  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  // Navegación de páginas
  const nextPage = () => {
    if (pageNumber < numPages) {
      setPageNumber(pageNumber + 1);
    }
  };

  const prevPage = () => {
    if (pageNumber > 1) {
      setPageNumber(pageNumber - 1);
    }
  };

  // Función para descargar el PDF completo
  const downloadPDF = () => {
    try {
      if (pdfActa) {
        const pdfDataUri = `data:application/pdf;base64,${pdfActa}`;

        const link = document.createElement('a');
        link.href = pdfDataUri;
        link.download = createNamePdf(tipoActa, idMonitoreo, idActa);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const generatePDF = () => {
    try {
      if (open) {
        return (
          <Row className="pdf">
            {ultimaActualizacion && (
              <div className="container-info-pdf">
                <span className="date-label">{`Fecha de actualización: ${ultimaActualizacion}`}</span>
                <span className="user-label">{`Usuario: ${usuario}`}</span>
              </div>
            )}
            <div
              style={{
                overflowY: 'auto',
                height: '500px', // Ajusta la altura según sea necesario
                padding: '10px 20px',
                border: '1px solid #eaeaea',
                borderRadius: '5px',
                backgroundColor: '#f9f9f9'
              }}>
              <Document
                file={`data:application/pdf;base64,${pdfActa}`}
                onLoadSuccess={onDocumentLoadSuccess}>
                <Page pageNumber={pageNumber} />
              </Document>
            </div>
            <div style={{ marginTop: 20, textAlign: 'center' }}>
              <Button onClick={prevPage} disabled={pageNumber <= 1} style={{ marginRight: 10 }}>
                Anterior
              </Button>
              <Button
                onClick={nextPage}
                disabled={pageNumber >= numPages}
                style={{ marginLeft: 10 }}>
                Siguiente
              </Button>
              <p style={{ margin: 10 }}>
                Página {pageNumber} de {numPages}
              </p>
              {!ultimaActualizacion && (
                <Button type="primary" onClick={downloadPDF}>
                  Descargar PDF
                </Button>
              )}
            </div>
          </Row>
        );
      }
    } catch (error) {
      console.log('Error', error);
    }

    return null;
  };

  const handleCancel = () => {
    callback(false);
    setPageNumber(1);
  };

  return (
    <Modal footer={null} width="40%" open={open} onCancel={handleCancel} centered>
      <Row>
        <Col span={24}>
          <h2 style={{ fontWeight: '600' }} className={titulo ? 'pink-font' : ''}>
            {titulo || selectedActaType(tipoActa)}
          </h2>
        </Col>
      </Row>
      <div>{generatePDF()}</div>
    </Modal>
  );
};

const DescargaPDF = (pdfActa, tipoActa, idMonitoreo, idActa) => {
  try {
    if (pdfActa) {
      const pdfDataUri = `data:application/pdf;base64,${pdfActa}`;

      const link = document.createElement('a');
      link.href = pdfDataUri;
      link.download = createNamePdf(tipoActa, idMonitoreo, idActa);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  } catch (error) {
    console.log('Error:', error);
  }
};

export { ModalPdf, DescargaPDF };

ModalPdf.propTypes = {
  open: PropTypes.bool.isRequired,
  tipoActa: PropTypes.number.isRequired,
  callback: PropTypes.func.isRequired,
  pdfActa: PropTypes.string.isRequired,
  ultimaActualizacion: PropTypes.string,
  usuario: PropTypes.string,
  titulo: PropTypes.string,
  idMonitoreo: PropTypes.number,
  idActa: PropTypes.number
};

ModalPdf.defaultProps = {
  ultimaActualizacion: null,
  usuario: null,
  titulo: null,
  idMonitoreo: null,
  idActa: null
};

DescargaPDF.propTypes = {
  pdfActa: PropTypes.string.isRequired,
  tipoActa: PropTypes.number.isRequired,
  idMonitoreo: PropTypes.number.isRequired,
  idActa: PropTypes.number.isRequired
};
